import { render, staticRenderFns } from "./UiLoader.vue?vue&type=template&id=401dbbaa&lang=pug"
import script from "./UiLoader.vue?vue&type=script&lang=js"
export * from "./UiLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports